<template>
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.JobSource name") }} (ENG)
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-4">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="job.jobSourceName"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'jobSourceName'"
                      maxLength="30"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">{{ errors.first('jobSourceName') }}</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.JobSource name") }} (繁體)
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-4">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="job.jobSourceNameHk"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'jobSourceNameHk'"
                      maxLength="10"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">{{ errors.first('jobSourceNameHk') }}</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.JobSource name") }} (简体)
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-4">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="job.jobSourceNameCn"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'jobSourceNameCn'"
                      maxLength="10"
                      autocomplete="off"
                    />
                  </div>
                  <label class="error">{{ errors.first('jobSourceNameCn') }}</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Instant Filter") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-4">
                  <div>
                    <select class="form-control" v-model="job.instantFilter" name="topBannerId">
                      <option value="false">
                        {{ $t("message.Off") }}
                      </option>
                      <option value="true">
                        {{ $t("message.On") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Import") }}
                  <span style="color:red" v-if="!this.$route.query.id">*</span>
                </label>
                <div class="col-sm-2">
                  <input style="margin-top: 5px" class="" type="file" ref="file" accept="xls/*" @change="handleFileUpload()" />
                </div>

                <div class="col-sm-3" v-if="job.xlsFile">
                  <div style="margin-top: 8px">
                    {{job.xlsFile.name}}
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="btn btn-primary" @click="exportShortTermJobTemplateXls()">
                    {{ $t("message.download") }}
                  </div>
                </div>
              </div>

              <div class="form-group" v-if="job.originalFilename">
                <label class="col-sm-2 control-label">
                  {{$t("message.lastFile") }}
                </label>
                <div class="col-sm-3">
                  <div style="margin-top: 7px">
                    <a :href="job.xlsFullFileName" target="_blank">{{job.originalFilename}}</a>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      job: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.id = id;
        let data = await this.$store.dispatch("getShortTermJobDetail", this.setPostData(obj));

        this.$set(this, "job", data.data.result);
      } else {
        let initJob = {
          jobSourceName: "",
          jobSourceNameHk: "",
          jobSourceNameCn: "",
          instantFilter: "false",
          xlsFile: "",
          status: 1,
        };
        this.$set(this, "job", initJob);
      }
    },
    showWarning(type) {
      var that =this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            },{
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if(this.$route.query.id) {
          if (!vresult) {
            return;
          }
        } else {
          if (!vresult || !this.job.xlsFile) {
            return;
          }
        }

        let obj = this.getAuthObj;
        for(var key in this.job){
          obj[key] = this.job[key];
        }

        if(this.$route.query.id){
          var data = await this.$store.dispatch("updateShortTermJob", this.setPostData(obj));
        }else{
          var data = await this.$store.dispatch("createShortTermJob", this.setPostData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.ids = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteShortTermJob", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleFileUpload() {
      // this.job.xlsFile = this.$refs.file.files[0];
      this.$set(this.job, "xlsFile", this.$refs.file.files[0]);
      this.$refs.file.value = null;
    },
    exportShortTermJobTemplateXls() {
      let obj = this.getAuthObj;
      let url = `${config.domain}/exportShortTermJobTemplateXls?userId=${obj.userId}&session=${obj.session}&lang=${obj.lang}`
      window.open(url)
    },
    setPostData(data){
      var params = new FormData();
      for(var key in data){
        if(data[key]!==null&&data[key]!==undefined){
          params.append(key, data[key]);
        }
      }
      return params;
    }
  },
};
</script>
